export default __webpack_public_path__ + "static/media/heart.cd3ce455.svg";